import React, {createContext, useState, useCallback, useEffect, useContext} from 'react';
import Error from "../components/Error";
import {useTranslation} from "react-i18next";
import EnvCtx from "./EnvCtx";

const CameraCntx = createContext();

export const CameraCntxProvider = (props) => {
    const { i18n, t } = useTranslation();
    const [errore, setErrore] = useState(null);
    const [error, setError] = useState(null);
    const [mediazione, setMediazione] = useState();
    const [selectedMediazione, setSelectedMediazione] = useState('');
    const [selectedIva, setSelectedIva] = useState('IVA_inclusa');
    const [sezioneA, setSezioneA] = useState('');
    const [liteA, setLiteA] = useState();
    const [selectedLiteA, setSelectedLiteA] = useState('');
    const [tipiSpesaA, setTipiSpesaA] = useState([]);
    const [listValoreA, setListValoreA] = useState([]);
    const [spesaRaccomandata, setSpesaRaccomandata] = useState(0);
    const [inputAColore, setInputAColore] = useState({});
    const [raccomandataValues, setRaccomandataValues] = useState({});
    const [ivaRaccomandata, setIvaRaccomandata] = useState(0.0);
    const [totaleA, setTotaleA] = useState(0.0);
    const [ivaA, setIvaA] = useState(0.0);
    const [sezioneB, setSezioneB] = useState('');
    const [liteB, setLiteB] = useState();
    const [selectedLiteB, setSelectedLiteB] = useState('');
    const [tipiSpesaB, setTipiSpesaB] = useState([]);
    const [listValoreB, setListValoreB] = useState([]);
    const [selectedTipoSpesaB, setSelectedTipoSpesaB] = useState(null);
    const [selectedRadioB, setSelectedRadioB] = useState(null);
    const [totaleB, setTotaleB] = useState(0.0);
    const [ivaB, setIvaB] = useState(0.0);
    const [sezioneC, setSezioneC] = useState('');
    const [tipiSpesaC, setTipiSpesaC] = useState([]);
    const [selectedTipoSpesaC, setSelectedTipoSpesaC] = useState(null);
    const [ivaC, setIvaC] = useState(0.0);
    const [totaleC, setTotaleC] = useState(totaleB);
    const [totale, setTotale] = useState(0.0);
    const [totaleIvaSpesa, setTotaleIva] = useState(0,0);
    const [showErrorA, setShowErrorA] = useState(false);
    const [showErrorB, setShowErrorB] = useState(false);
    const [showErrorC, setShowErrorC] = useState(false);
    const [showErrorPdf, setShowErrorPdf] = useState(false);
    const [mediazioneDanger, setMediazioneDanger] = useState(false);
    const [liteAdanger, setLiteAdanger] = useState(false);
    const [liteBdanger, setLiteBdanger] = useState(false);
    const [radioBdanger, setRadioBdanger] = useState(false);
    const [errorLiteApdf, setErrorLiteApdf] = useState(false);
    const [descrezioneCamera, setDescrezioneCamera] = useState("");
    const [siglaCamera, setSiglaCamera] = useState("");
    const [testoFooter, setTestoFooter] = useState("");
    const [testoFooterEn, setTestoFooterEn] = useState("");
    const [isSezioniLoading, setIsSezioniLoading] = useState(false);
    const [isSezioniLoaded, setIsSezioniLoaded] = useState(false);

    const getDescrizioneCamera = useCallback(async () => {
        try {
            const response = await fetch(window.prmeLocationOrigin +'/cciaa/getcamera');
            if (response.status !== 200) {
                throw new Error("Errore nella chiamata!");
            }
            const data = await response.json();
            const camera = data.risposta;
            setDescrezioneCamera(camera.descrizione);
            setSiglaCamera(camera.sigla);
            setTestoFooter(camera.testoFooter);
            setTestoFooterEn(camera.testoFooterEn);
        } catch (er) {
            return er.message;
        }
    }, []);

    const fetchJson = async (url) => {
        const response = await fetch(url);
        const status = response.status;
        const json = await response.json().catch(() => null);
        return { status, json };
    };

    useEffect(() => {
        getDescrizioneCamera();
        if (!mediazione) {
            const getMediazioneByCamera = async () => {
                try {
                    const response = await fetch(window.prmeLocationOrigin + '/cciaa/getlistamediazionepercamera');
                    if (!response.ok) {
                        throw new Error("Errore nella chiamata!");
                    }
                    const data = await response.json();
                    setMediazione(data.risposta);
                } catch (er) {
                    setErrore(er.message);
                }
            };
            getMediazioneByCamera();
        }
    }, [mediazione, getDescrizioneCamera]);

    const initializeInputValues = useCallback(() => {
        const initialValues = {};
        const initialcolore = {};
        tipiSpesaA.forEach(tipo => {
            if (/^raccomandata[A-Za-z]*$/.test(tipo.chiave)) {
                initialValues[tipo.chiave] = 0;
                initialcolore[tipo.chiave] = "inherit";
            }
        });
        setRaccomandataValues(initialValues);
        setInputAColore(initialcolore);
    },[tipiSpesaA]);

    const getLitiByCamera = useCallback(async (chaiveSezione) => {
        try {
            const response = await fetch(window.prmeLocationOrigin +'/cciaa/getlistalitipercamera/' + chaiveSezione);
            if (response.status !== 200) {
                throw new Error("Errore nella chiamata!");
            }
            const data = await response.json();
            setLiteA(data.risposta);
        } catch (er) {
            setErrore(er.message);
        }
    }, [setLiteA]);

    const getLitiByCameraAndPadre = useCallback(async (chiaveSezione) => {
        try {
            const response = await fetch(window.prmeLocationOrigin +'/cciaa/getlistalitipercameraepadre/' + chiaveSezione + '/' + selectedLiteA.id);
            if (response.status !== 200) {
                throw new Error("Errore nella chiamata!");
            }
            const data = await response.json();
            setLiteB(data.risposta);
            console.log(data.risposta);
        } catch (er) {
            setErrore(er.message);
        }
    }, [setLiteB , selectedLiteA]);

    const getSezioneByChiave = useCallback(async (chiave) => {
        try {
            const { status, json } = await fetchJson(`${window.prmeLocationOrigin}/cciaa/getsezionebychiave/${chiave}`);
            if (status === 404) {
                if (chiave === "A") setSezioneA(null);
                else if (chiave === "B") setSezioneB(null);
                else if (chiave === "C") setSezioneC(null);
                return null;
            }
            if (status !== 200) {
                throw new Error("Errore nella chiamata: " + status);
            }
            const result = json?.risposta ?? null;
            if (chiave === "A") setSezioneA(result);
            else if (chiave === "B") setSezioneB(result);
            else if (chiave === "C") setSezioneC(result);
            return result;
        } catch (er) {
            setErrore(typeof er === "string" ? er : (er.message || "Errore di rete"));
            if (chiave === "A") setSezioneA(null);
            else if (chiave === "B") setSezioneB(null);
            else if (chiave === "C") setSezioneC(null);
            return null;
        }
    }, [setSezioneA, setSezioneB, setSezioneC]);

    const getTipiSpesaByCamera = useCallback(async (chiaveSezione) => {
        try {
            const { status, json } = await fetchJson(window.prmeLocationOrigin + '/cciaa/getlistatipispesapercamera/' + chiaveSezione);
            if (status !== 200) {
                throw new Error("Errore nella chiamata: " + status);
            }
            const data = (json?.risposta || [])
            if (chiaveSezione === "A") setTipiSpesaA(data);
            else if (chiaveSezione === "B") setTipiSpesaB(data);
            else if (chiaveSezione === "C") setTipiSpesaC(data);
            return data;
        } catch (er) {
            setErrore(er.message);
            return [];
        }
    }, [setTipiSpesaA, setTipiSpesaB, setTipiSpesaC]);

    useEffect(() => {
        let cancelled = false;

        const initSezioni = async () => {
            setIsSezioniLoading(true);
            setIsSezioniLoaded(false);
            try {
                const calls = ["A", "B", "C"].map(async (chiave) => {
                    const sezione = await getSezioneByChiave(chiave);
                    const tipi = await getTipiSpesaByCamera(chiave).catch(() => []);
                    return { chiave, sezione, tipi };
                });

               await Promise.all(calls);

                if (!cancelled) {
                    setIsSezioniLoaded(true);
                }
            } catch (e) {
                if (!cancelled) {
                    setErrore(e.message || "Errore init sezioni");
                }
            } finally {
                if (!cancelled) setIsSezioniLoading(false);
            }
        };

        initSezioni();

        return () => { cancelled = true; };
    }, [getSezioneByChiave, getTipiSpesaByCamera]);

    const getValoreSpesa = useCallback(async (selectedMediazione, selectedLite, chiaveSezione, chiavetipoSpesa) => {
        try {
            if (selectedMediazione && selectedLite && chiavetipoSpesa) {
                const response = await fetch(window.prmeLocationOrigin + '/cciaa/getvalorespesa/' + selectedMediazione.id + '/' + selectedLite + '/' + chiaveSezione + '/' + chiavetipoSpesa);
                if (response.status !== 200) {
                    throw new Error("Errore nella chiamata!");
                }
                const data = await response.json();
                return (data.risposta);
            }
        } catch (er) {
            setErrore(er.message);
        }
    }, []);

    const getCalculatedValoreByFormulaMediazioneVolontaria = useCallback(async (chiave, padreId, liteId, valore) => {
        try {
            const response = await fetch(`${window.prmeLocationOrigin}/cciaa/getCalculatedValoreByFormulaMediazioneVolontaria/${chiave}/${padreId}/${liteId}/${valore}`);
            if (response.status !== 200) {
                throw new Error("Errore nella chiamata!");
            }
            const data = await response.json();
            return data.risposta;
        } catch (er) {
            setErrore(er.message);
        }
    }, [setErrore]);

    const getCalculatedValoreByFormulaMediazioneObbligatoria = useCallback(async (chiave, padreId, liteId, valore) => {
        try {
            const response = await fetch(`${window.prmeLocationOrigin}/cciaa/getCalculatedValoreByFormulaMediazioneObbligatoria/${chiave}/${padreId}/${liteId}/${valore}`);
            if (response.status !== 200) {
                throw new Error("Errore nella chiamata!");
            }
            const data = await response.json();
            return data.risposta;
        } catch (er) {
            setErrore(er.message);
        }
    }, [setErrore]);

    const calculateTotalRaccomandata = useCallback (() => {
        let total = 0;
        let valoreIva = 0.0;
        if (raccomandataValues) {
            for (const key in raccomandataValues) {
                const value = raccomandataValues[key];
                const quantity = parseInt(value, 10);
                if (listValoreA) {
                    const item = listValoreA.find(item => item.tipo === key);
                    const price = selectedIva === "IVA_inclusa" ? item.valore.conIva : item.valore.senzaIva;
                    if(selectedIva === "IVA_inclusa") {
                        valoreIva += ((item.valore.conIva - item.valore.senzaIva) * quantity);
                    }
                    total += quantity * price;
                }
            }
        }
        return { total, valoreIva };
    },[listValoreA, selectedIva, raccomandataValues]);

    const calculTotalA = useCallback(() => {
        let total = 0;
        let ivaSpesa = 0.0;
        if (selectedLiteA) {
            if (listValoreA) {
                listValoreA.forEach(item => {
                    tipiSpesaA.forEach(tipo => {
                        if (tipo.chiave === item.tipo && !/^raccomandata[A-Za-z]*$/.test(tipo.chiave)) {
                            total += selectedIva === "IVA_inclusa" ? item.valore.conIva : item.valore.senzaIva;
                            if(selectedIva === "IVA_inclusa") {
                                ivaSpesa += (item.valore.conIva - item.valore.senzaIva);
                            }
                        }
                    });
                });
            } else { return 0}
        }
        total += spesaRaccomandata;
        ivaSpesa += ivaRaccomandata;
        return  { total, ivaSpesa };
    }, [selectedLiteA, listValoreA, spesaRaccomandata, ivaRaccomandata, selectedIva, tipiSpesaA]);

    const calculTotalB = useCallback(() => {
        let total = 0;
        let ivaSpesa = 0.0;
        if (selectedLiteB) {
            if (listValoreB) {
                if (listValoreB.length === 1) {
                    const valoreB = listValoreB[0];
                    total = selectedIva === "IVA_inclusa" ? valoreB.valore.conIva : valoreB.valore.senzaIva;
                    if (selectedIva === "IVA_inclusa") {
                        ivaSpesa += (valoreB.valore.conIva - valoreB.valore.senzaIva)
                    }
                } else if (selectedTipoSpesaB && listValoreB.length > 1) {
                    const selectedValore = listValoreB.find(item => item.tipo === selectedTipoSpesaB.tipo);
                    if (selectedValore) {
                        total = selectedIva === "IVA_inclusa" ? selectedValore.valore.conIva : selectedValore.valore.senzaIva;
                        if (selectedIva === "IVA_inclusa") {
                            ivaSpesa += (selectedValore.valore.conIva - selectedValore.valore.senzaIva)
                        }
                    }
                }
            } else { return errore}
        }
        return { total , ivaSpesa } ;
    },[selectedLiteB, listValoreB, selectedTipoSpesaB, selectedIva, errore]);

    const calculTotalC = useCallback((selectedTipoSpesaC) => {
        let total = 0;
        let ivaSpesa = 0.0;
        if (selectedLiteB && selectedTipoSpesaB) {
            if(selectedTipoSpesaC) {
                if (/^min[A-Za-z]*$/.test(selectedTipoSpesaC.chiave)) {
                    total += (0.10 * totaleB);
                    ivaSpesa += (0.10 * ivaB);
                } else if (/^mas[A-Za-z]*$/.test(selectedTipoSpesaC.chiave)) {
                    total += (0.25 * totaleB);
                    ivaSpesa += (0.25 * ivaB);
                } else return { total: 0, ivaSpesa: 0 };
            }
        }
        return { total , ivaSpesa };
    },[selectedLiteB, selectedTipoSpesaB, totaleB, ivaB]);

    useEffect(() => {
        setSelectedLiteA(null);
        initializeInputValues();
        setRaccomandataValues({});
        setSelectedLiteB(null);
        setSelectedTipoSpesaB(null);
        setSelectedRadioB(null);
        setSelectedTipoSpesaC(null);
    },[selectedMediazione.id, initializeInputValues])

    useEffect(() => {
        const { total, valoreIva } = calculateTotalRaccomandata();
        setSpesaRaccomandata(total);
        setIvaRaccomandata(valoreIva);
    }, [raccomandataValues, listValoreA, selectedIva, setSpesaRaccomandata, setIvaRaccomandata, calculateTotalRaccomandata, error]);

    useEffect(() => {
        const { total, ivaSpesa } = calculTotalA();
        setTotaleA(total);
        setIvaA(ivaSpesa);
    }, [selectedLiteA, listValoreA, spesaRaccomandata,selectedIva, setTotaleA, setIvaA, calculTotalA]);

    useEffect(() => {
        if (selectedLiteA && selectedLiteA.id) {
            setSelectedLiteB(null);
            setSelectedTipoSpesaB(null);
            setSelectedRadioB(null);
            setSelectedTipoSpesaC(null);
        }
    },[selectedLiteA])

    useEffect(() => {
        const { total, ivaSpesa } = calculTotalB();
        setTotaleB(total);
        setIvaB(ivaSpesa);
    }, [selectedLiteB, selectedTipoSpesaB, listValoreB, selectedIva, setTotaleB, setIvaB, calculTotalB]);

    useEffect(() => {
        const { total , ivaSpesa } = calculTotalC(selectedTipoSpesaC);
        setTotaleC(total);
        setIvaC(ivaSpesa);
    }, [selectedLiteB, selectedTipoSpesaB, selectedTipoSpesaC, totaleB, setTotaleC, setIvaC, calculTotalC]);

    useEffect(() => {
        const total = totaleA + totaleB + totaleC;
        console.log(totaleA);
        console.log(totaleB);
        console.log(totaleC);
        const iva = ivaA + ivaB + ivaC;
        setTotale(total);
        console.log(total);
        setTotaleIva(iva);
    }, [totaleA, totaleB, totaleC, totale, ivaA, ivaB, ivaC, totaleIvaSpesa]);

    const formatNumber = (number) => {
        if (typeof number === 'number' || typeof number === 'string') {
            const num = parseFloat(number.toString().replace(',', '.'));
            if (!isNaN(num)) {
                const [integerPart, decimalPart] = num.toFixed(2).split('.');
                const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                const formattedDecimalPart = decimalPart ? ',' + decimalPart.slice(0, 2) : '';
                return formattedIntegerPart + formattedDecimalPart;
            }
        } else if (number === undefined || number === null) {
            return '0,00';
        } else {
            return number;
        }
    };

    const getDescrizioneByLingua = (item) => {
        if (i18n.language === 'it') {
            return item.descrizione;
        } else if (i18n.language === 'en') {
            return item.descrizioneEn;
        }
    };

    const getSottoTitoloByLingua = (item) => {
        if (i18n.language === 'it') {
            return item.sottoTitolo;
        } else if (i18n.language === 'en') {
            return item.sottoTitoloEn;
        }
    };

    const getTestoSezioneByLingua = (item) => {
        if (i18n.language === 'it') {
            return item.testo;
        } else if (i18n.language === 'en') {
            return item.testoEn;
        }
    };

    const getDescrizioneLivelloByLingua = (item) => {
        if (i18n.language === 'it') {
            return item.descrizioneLivello;
        } else if (i18n.language === 'en') {
            return item.descrizioneLivelloEn;
        }
    };

    const handleErrorClick = (chiave) => {
        const showError = (errorType, setShowErrorState, setTimeoutState) => {
            setError(t(errorType));
            setShowErrorState(true);
            setTimeout(() => setShowErrorState(false), 5000);
            setTimeout(() => setTimeoutState(false), 5000);
        };

        switch (true) {
            case !selectedMediazione:
                setError(t("errore.tipologia"));
                setMediazioneDanger(true);
                switch (chiave) {
                    case "A":
                        showError("errore.tipologia", setShowErrorA, setMediazioneDanger);
                        break;
                    case "B":
                        showError("errore.tipologia", setShowErrorB, setMediazioneDanger);
                        break;
                    case "C":
                        showError("errore.tipologia", setShowErrorC, setMediazioneDanger);
                        break;
                    case "SF":
                        showError("errore.tipologia", setShowErrorPdf, setMediazioneDanger);
                        break;
                    default:
                        break;
                }
                break;

            case selectedMediazione && !selectedLiteA:
                setLiteAdanger(true);
                switch (chiave) {
                    case "A":
                        showError("errore.valore", setShowErrorA, setLiteAdanger);
                        break;
                    case "B":
                        showError("errore.liteA", setShowErrorB, setLiteAdanger);
                        break;
                    case "C":
                        showError("errore.liteA", setShowErrorC, setLiteAdanger);
                        break;
                    case "SF":
                        showError("errore.valore", setErrorLiteApdf, setLiteAdanger);
                        break;
                    default:
                        break;
                }
                break;

            case selectedLiteA && !selectedLiteB:
                switch (chiave) {
                    case "B":
                        setLiteBdanger(true);
                        showError("errore.valore", setShowErrorB, setLiteBdanger);
                        break;
                    case "C":
                        setLiteBdanger(true);
                        showError("errore.liteB", setShowErrorC, setLiteBdanger);
                        break;
                    default:
                        break;
                }
                break;

            case selectedLiteB && !selectedTipoSpesaB:
                if (chiave === "C") {
                    setRadioBdanger(true);
                    showError("errore.tipoSpesa", setShowErrorC, setRadioBdanger);
                }
                break;

            default:
                setShowErrorA(false);
                setShowErrorB(false);
                setShowErrorC(false);
                break;
        }
    };

    function buildSezioneTitle(sezione) {
        if (!sezione || !sezione.chiave) return '';
        const desc = getDescrizioneByLingua(sezione);
        return `${sezione.chiave}. ${desc || ''}`;
    }

    const generatePdf = async () => {
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().replace(/[-:T]/g, '').slice(0, 14);
        const camera = descrezioneCamera;
        const sigla = siglaCamera;
        const lingua = i18n.language;
        const sezioneAtitle = buildSezioneTitle(sezioneA);
        const sezioneBtitle = buildSezioneTitle(sezioneB);
        const sezioneCtitle = buildSezioneTitle(sezioneC);
        const spesaA = tipiSpesaA.map(tipo => {
            const matchingItem = listValoreA.find(item => tipo.chiave === item.tipo);
            if (matchingItem && !/^raccomandata[A-Za-z]*$/.test(tipo.chiave)) {
                return {
                    tipoSpesa: getDescrizioneByLingua(tipo),
                    valore: formatNumber(matchingItem.valore.senzaIva),
                    valoreConIva: formatNumber(matchingItem.valore.conIva)
                };
            } else {
                return null;
            }
        }).filter(item => item !== null);
        const valoreIvaA = formatNumber(ivaA);
        const valoreIvaB = formatNumber(ivaB);
        const valoreIvaC = formatNumber(ivaC);
        const totaleIva = formatNumber(totaleIvaSpesa);
        const totaleSpesaA = formatNumber(totaleA);
        const totaleSpesaB = formatNumber(totaleB);
        const totaleSpesaC = formatNumber(totaleC);
        const totaleSpesa = formatNumber(totale);
        const spesaRaccomandataTotale = formatNumber(spesaRaccomandata);
        const pdfRequest = {
            sigla,
            lingua,
            selectedIva,
            descrizioneMediazione: selectedMediazione ? getDescrizioneByLingua(selectedMediazione) : "",
            sezioneAtitle,
            liteA : selectedLiteA ? getDescrizioneLivelloByLingua(selectedLiteA) : "",
            spesaA: spesaA.reduce((acc, cur) => {
                acc[cur.tipoSpesa] = acc[cur.tipoSpesa] || {};
                acc[cur.tipoSpesa] = {
                    valore: cur.valore,
                    valoreConIva: cur.valoreConIva
                };
                return acc;
            }, {}),
            spesaRaccomandataTotale,
            valoreIvaA,
            totaleSpesaA,
            sezioneBtitle,
            liteB : selectedLiteB ? getDescrizioneLivelloByLingua(selectedLiteB) : "",
            valoreIvaB,
            totaleSpesaB,
            sezioneCtitle,
            tipoSpesaC : selectedTipoSpesaC ? getDescrizioneByLingua(selectedTipoSpesaC) : "",
            valoreIvaC,
            totaleSpesaC,
            totaleIva,
            totaleSpesa
        };

        try {
            const response = await fetch(window.prmeLocationOrigin +'/cciaa/downloadpdf', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(pdfRequest),
            });
            if (!response.ok) {
                throw new Error('Failed to generate PDF');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.download = `Preventivo_Mediazione_${camera}_${formattedDate}.pdf`;
            a.href = url;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    };

    const cameraCntxValue = {
        errore, setErrore,
        error, setError,
        mediazione, setMediazione,
        selectedMediazione, setSelectedMediazione,
        selectedIva, setSelectedIva,
        sezioneA, setSezioneA,
        liteA, setLiteA,
        selectedLiteA, setSelectedLiteA,
        tipiSpesaA, setTipiSpesaA,
        listValoreA, setListValoreA,
        spesaRaccomandata, setSpesaRaccomandata,
        inputAColore, setInputAColore,
        raccomandataValues, setRaccomandataValues,
        ivaRaccomandata, setIvaRaccomandata,
        totaleA, setTotaleA,
        ivaA, setIvaA,
        sezioneB, setSezioneB,
        liteB, setLiteB,
        selectedLiteB, setSelectedLiteB,
        tipiSpesaB, setTipiSpesaB,
        listValoreB, setListValoreB,
        selectedTipoSpesaB, setSelectedTipoSpesaB,
        selectedRadioB, setSelectedRadioB,
        totaleB, setTotaleB,
        ivaB, setIvaB,
        sezioneC, setSezioneC,
        tipiSpesaC, setTipiSpesaC,
        selectedTipoSpesaC, setSelectedTipoSpesaC,
        totaleC, setTotaleC,
        ivaC, setIvaC,
        totale, setTotale,
        totaleIvaSpesa, setTotaleIva,
        showErrorA, setShowErrorA,
        showErrorB, setShowErrorB,
        showErrorC, setShowErrorC,
        showErrorPdf, setShowErrorPdf,
        mediazioneDanger, setMediazioneDanger,
        liteAdanger, setLiteAdanger,
        liteBdanger, setLiteBdanger,
        radioBdanger, setRadioBdanger,
        errorLiteApdf, setErrorLiteApdf,
        descrezioneCamera, setDescrezioneCamera,
        siglaCamera,
        isSezioniLoading, isSezioniLoaded,
        testoFooter,
        testoFooterEn,
        getDescrizioneCamera,
        getLitiByCamera,
        getLitiByCameraAndPadre,
        getTipiSpesaByCamera,
        getSezioneByChiave,
        getValoreSpesa,
        getCalculatedValoreByFormulaMediazioneVolontaria,
        getCalculatedValoreByFormulaMediazioneObbligatoria,
        calculateTotalRaccomandata,
        calculTotalA,
        calculTotalB,
        calculTotalC,
        initializeInputValues,
        handleErrorClick,
        formatNumber,
        getDescrizioneByLingua,
        getSottoTitoloByLingua,
        getTestoSezioneByLingua,
        getDescrizioneLivelloByLingua,
        generatePdf
    };

    return (
        <CameraCntx.Provider value={cameraCntxValue}>
            {props.children}
        </CameraCntx.Provider>
    );
};

export default CameraCntx;
